import React, { FC } from 'react'

import { AllowedIpListItem } from 'src/components/organisms'

import { AllowedIpEntity, NewAllowedIpId } from 'src/types'

type Props = {
  allowedIps: Array<AllowedIpEntity | NewAllowedIpId>
  afterCrud: () => void
  deleteNewItem: (newItemId: NewAllowedIpId) => void
  className?: string
}

export const AllowedIpList: FC<Props> = ({ allowedIps, afterCrud, deleteNewItem, className }) => {
  return (
    <div className={className}>
      <ul>
        {allowedIps.map(allowedIp => (
          <li
            key={typeof allowedIp === 'string' ? allowedIp : allowedIp.id}
            className="tw-mt-s0 first:tw-mt-0"
          >
            <AllowedIpListItem
              allowedIp={allowedIp}
              afterCrud={afterCrud}
              deleteNewItem={deleteNewItem}
            />
          </li>
        ))}
      </ul>
    </div>
  )
}
